import { createResourceReducer, typedResourceService } from './resourceReducer'

const { reducer, actions, thunks } = createResourceReducer({
    sliceName: 'policies',
    label: 'Policy',
    labelPlural: 'Policies',
    service: typedResourceService('Policy'),
})

export const { appendResource: appendPolicy, destroyResource: destroyPolicy, changeResource: changePolicy } = actions
export const { createResource: createPolicy, initializeResources: initializePolicies, deleteResource: deletePolicy, updateResource: updatePolicy, searchResources: searchPolicies, refreshResource: refreshPolicy } = thunks

export default reducer
